import { Coupon, CouponObject } from '@/helpers/interfaces';

const sortCoupon = (couponList: Coupon[]): Coupon[] =>{
  couponList.sort((a, b) => a.rowNumber - b.rowNumber)
  const results: CouponObject = couponList.reduce(function(results, org) {
    (results[org.rowNumber] = results[org.rowNumber] || []).push(org);
    return results;
  }, {})
  let sortedList: Coupon[] = []
  for(const [key, value] of Object.entries(results)){
    value.sort((a, b) => a.columnNumber - b.columnNumber)
    sortedList = [...sortedList, ...value]
  }
  return sortedList
}

export default sortCoupon
